import { gql } from '@apollo/client';

export const confirmWsPay = gql`mutation confirmCheckoutWSPaySignature($params: ConfirmCheckoutWSPaySignatureInput!) {
  confirmCheckoutWSPaySignature(params: $params){
    success
    alreadyPaid
  }
}`
